export default __webpack_public_path__ + "static/media/expl-nn_10_DE.d4c1d866.png";